module.exports = __webpack_public_path__ + "img/aufWildenGewässern.6ef4c3dd.svg";